import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CommentsState } from './comments.state';

const selectCommentsState = createFeatureSelector<CommentsState>('comments');

export const selectDocumentComments = createSelector(selectCommentsState, state => state.documentComments);
export const selectLoadingComments = createSelector(selectCommentsState, state => state.loadingComments);

export const selectErrorMessage = createSelector(selectCommentsState, state => state.errorMessage);
